export default __webpack_public_path__ + "static/mobile_14-cd66ddd25b8c1ad981fc4238cfd40ef5.webp";